import './App.css';
import Loader from './components/loader';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Loader/>
      </header>
    </div>
  );
}

export default App;
